export default __webpack_public_path__ + "static/media/koffingTex.f198287c.jpg";